// Module
var code = "<div>\n    <div data-bind=\"foreach: performanceStatusItems\">\n    <!-- ko component: { name: \"vessel-performance-status-item\", params: {longTrend: $data} } --><!-- /ko -->\n    </div>\n</div>\n<p class=\"tips\">\n    Parameters may be excluded from the overall performance status by clearing the appropriate checkbox\n</p>\n";
// Exports
module.exports = code;